import { PenLine } from "lucide-react";
import { formatDate } from "./prosthesis-meta";

export type AlteracaoDePrazo = {
  valorAntes: string | null;
  motivo: string | null;
  createdAt: Date | string;
  user?: { name: string | null } | null;
};

/**
 * O prazo do pedido, nas duas pontas. Mudado pelo laboratório, diz isso logo embaixo, com o prazo
 * que a clínica pediu e o motivo — data trocada sem rastro pegava a clínica de surpresa com o
 * paciente marcado. `onAlterar` só no laboratório.
 */
export function PrazoDoPedido({
  deadline,
  alteracoes,
  onAlterar,
}: {
  deadline: Date | string | null;
  alteracoes?: AlteracaoDePrazo[];
  onAlterar?: () => void;
}) {
  const ultima = alteracoes?.at(-1);
  const pedido = alteracoes?.[0]?.valorAntes;
  return (
    <div>
      <p className="text-[11px] uppercase tracking-wide text-zinc-500 dark:text-muted-foreground">Prazo</p>
      <p className="flex flex-wrap items-center gap-x-2 text-sm font-medium text-zinc-900 dark:text-foreground">
        {formatDate(deadline)}
        {onAlterar && (
          <button
            type="button"
            onClick={onAlterar}
            aria-label="Alterar prazo"
            className="inline-flex items-center gap-1 text-xs font-semibold text-brand-700 hover:underline dark:text-primary"
          >
            <PenLine className="h-3 w-3" />
            Alterar
          </button>
        )}
      </p>
      {ultima && (
        <p
          className="mt-0.5 text-[11.5px] leading-snug text-amber-700 dark:text-amber-400"
          title={`Mudado em ${formatDate(ultima.createdAt)}${ultima.user?.name ? ` por ${ultima.user.name}` : ""}`}
        >
          Mudado pelo laboratório{pedido ? ` · era ${formatDate(pedido)}` : ""}
          {ultima.motivo ? ` · ${ultima.motivo}` : ""}
        </p>
      )}
    </div>
  );
}
